import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Paper,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";

const AfeSearchBox = ({ onSearch }) => {
  const [afeCode, setAfeCode] = useState("");
  const [fiscalYear, setFiscalYear] = useState("");
  const [responsible, setResponsible] = useState("");
  const [userResponsible, setUserResponsible] = useState("");

  const handleSearch = () => {
    onSearch({
      afeCode: afeCode.trim(),
      fiscalYear: fiscalYear.trim(),
      responsible: responsible.trim(),
      userResponsible: userResponsible.trim(),
    });
  };

  const handleClear = () => {
    setAfeCode("");
    setFiscalYear("");
    setResponsible("");
    setUserResponsible("");
    onSearch({
      afeCode: "",
      fiscalYear: "",
      responsible: "",
      userResponsible: "",
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1,
        mb: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: "bold", color: "text.secondary", mr: 1 }}
      >
        Ricerca:
      </Typography>

      <TextField
        placeholder="AFE Code"
        variant="outlined"
        size="small"
        value={afeCode}
        onChange={(e) => setAfeCode(e.target.value)}
        onKeyPress={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                fontSize="small"
                color="action"
                sx={{ fontSize: 16 }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: { xs: "100%", sm: "180px" },
          "& .MuiOutlinedInput-root": {
            height: "36px",
          },
        }}
      />

      <TextField
        placeholder="Fiscal Year"
        variant="outlined"
        size="small"
        value={fiscalYear}
        onChange={(e) => setFiscalYear(e.target.value)}
        onKeyPress={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                fontSize="small"
                color="action"
                sx={{ fontSize: 16 }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: { xs: "100%", sm: "150px" },
          "& .MuiOutlinedInput-root": {
            height: "36px",
          },
        }}
      />

      <TextField
        placeholder="Responsible"
        variant="outlined"
        size="small"
        value={responsible}
        onChange={(e) => setResponsible(e.target.value)}
        onKeyPress={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                fontSize="small"
                color="action"
                sx={{ fontSize: 16 }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: { xs: "100%", sm: "150px" },
          "& .MuiOutlinedInput-root": {
            height: "36px",
          },
        }}
      />

      <TextField
        placeholder="User Responsible"
        variant="outlined"
        size="small"
        value={userResponsible}
        onChange={(e) => setUserResponsible(e.target.value)}
        onKeyPress={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                fontSize="small"
                color="action"
                sx={{ fontSize: 16 }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          width: { xs: "100%", sm: "150px" },
          "& .MuiOutlinedInput-root": {
            height: "36px",
          },
        }}
      />

      <Box sx={{ display: "flex", gap: 0.5, ml: "auto" }}>
        <Tooltip title="Cerca">
          <IconButton
            color="primary"
            onClick={handleSearch}
            size="small"
            sx={{
              bgcolor: "primary.main",
              color: "white",
              "&:hover": { bgcolor: "primary.dark" },
              width: "30px",
              height: "30px",
            }}
          >
            <SearchIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Pulisci">
          <IconButton
            onClick={handleClear}
            size="small"
            sx={{
              bgcolor: "grey.200",
              "&:hover": { bgcolor: "grey.300" },
              width: "30px",
              height: "30px",
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
};

export default AfeSearchBox;
